import { Modal, Tooltip, Input, Alert } from "antd";
import React from "react";
import { Controller } from "react-hook-form";

import {
  ChantButton,
  ChantCheckbox,
  ChantInput,
  ChantSelect,
  HelpTooltip,
} from "../../../../CommonComponents";
import BirthDayField from "./BirthdayField";
import SeasonTicketHolder from "./SeasonTicketHolder";
import useEditMember from "./useEditMember";

import "./EditMember.css";
import ChantSpinner from "../../../../CommonComponents/ChantSpinner/ChantSpinner";
import { InfoCircleOutlined } from "@ant-design/icons";
import { MemberRoleTooltipIcon } from "../../../../utils/icons";
import LeaderDetails from "./LeaderDetails";

let userRoles = ["admin", "member", "ticket-scanner", "capo", "leader", "fan"];

const ROLE_HELP_TOOLTIP = {
  admin: "Full access to the admin dashboard & app",
  "ticket-scanner": "Ability to scan group tickets",
  capo: "Access to engagement features in app. No admin dashboard access.",
  leader: "Full access to the app. No admin dashboard access.",
  fan: "Restricted app permissions",
};

const EditMember = ({ userDetails, userId, handleModalOpen }) => {
  const {
    resetState,
    onSubmit,
    watchedValues,
    setValue,
    control,
    formState,
    isSaving,
    fieldsLoading,
    renewalDate,
    sizes,
    registrationLayout,
    customFields,
    countryNames,
    years,
    packagesBySeason,
    currentPackages,
    setSelectedPackage,
    hasTshirt,
    hasChildren,
    selectedPackage,
    getCustomField,
    handleSubmit,
    stripeSubscriptionUrl,
    groupData,
  } = useEditMember(userDetails, userId, handleModalOpen);

  const isLinkedGroup = (groupData?.parents?.length ?? 0) > 0;
  const selectedRole = watchedValues?.userRole;

  return (
    <Modal
      width="auto"
      styles={{
        body: { height: "750" },
        padding: 0,
      }}
      className="edit-member-modal"
      centered
      open={userId && String(userId)?.length > 0}
      onCancel={() => {
        handleModalOpen();
        resetState();
      }}
      closable={false}
      footer={null}
    >
      <div
        className="edit-member-container"
        style={{
          borderRadius: "8px",
          height: "100%",
          overflow: "auto",
          // margin: "-20px -24px",
          position: "relative",
          // flexWrap: "wrap",
        }}
      >
        <div
          style={{
            cursor: "pointer",
            position: "absolute",
            top: 10,
            right: 20,
            zIndex: 10000,
          }}
          onClick={() => {
            handleModalOpen();
          }}
        >
          <span style={{ fontSize: 20 }}> &#x2715; </span>
        </div>
        <div
          // className="col-md-4"
          style={{
            background: "var(--primary-background)",
            width: "20% !important",
            minWidth: 350,
            maxWidth: 350,
            padding: "24px",
          }}
        >
          {userDetails.profileImage && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                // marginTop: 80,
                marginBottom: 30,
              }}
            >
              <div
                className="edit-member-profile-pic"
                style={{
                  borderRadius: "50%",
                  backgroundImage: `url(${userDetails.profileImage})`,
                  backgroundRepeat: "no-repeat",
                  overflow: "clip",
                  backgroundSize: "cover",
                }}
              ></div>
            </div>
          )}
          <div style={{ marginBottom: 40, marginTop: 30 }}>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                color: "var(--text-color)",
              }}
            >
              <div style={{ width: "100%" }}>
                <div style={{ fontSize: "26px", fontWeight: "bold" }}>
                  {userDetails.name}
                </div>
                <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                  {userDetails.title}
                </div>
                <div style={{ fontSize: "18px", fontWeight: "bold" }}>
                  {userDetails.userRole}
                </div>

                <div className="mt-4" style={{ height: "70%" }}>
                  <div style={{ fontSize: "14px", fontWeight: "bold" }}>
                    {userDetails?.packageName || ""}
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    Member since {userDetails.memberSince}
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    Member # {userDetails.membershipNumber}
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    Volunteer:{" "}
                    {userDetails.shareVolunteerOpportunities ? "Yes" : "No"}
                  </div>
                  <div style={{ fontSize: "14px" }}>
                    Send Email: {userDetails.joinedEmailList ? "Yes" : "No"}
                  </div>

                  {selectedPackage?.offerAutorenewal &&
                    userDetails?.subscriptionDetail?.status && (
                      <div>
                        Auto-renewal:{" "}
                        {userDetails.subscriptionDetail?.status === "active"
                          ? "Enabled"
                          : "Not Enabled"}
                        <div className="d-flex">
                          <a
                            href={stripeSubscriptionUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {" "}
                            Cancel{" "}
                          </a>

                          <Tooltip
                            placement="topLeft"
                            title={() => (
                              <div
                                style={{
                                  height: "fit-content",
                                  width: "400px",
                                  display: "flex",
                                  flexDirection: "column",
                                }}
                              >
                                Members have access to manage their subscription
                                in &apos;My Profile&apos; of the app. You can
                                also manage directly in Stripe. In the Stripe
                                subscription click the &apos;three dots&apos;
                                (top right) then &apos;Cancel
                                Subscription&apos;. A refund can be issued if
                                desired.
                              </div>
                            )}
                          >
                            <span className="border-0">
                              &nbsp;
                              <i className="fa fa-question-circle-o"></i>
                            </span>
                          </Tooltip>
                        </div>
                      </div>
                    )}

                  <div className="row">
                    <div className="col">
                      <div
                        style={{
                          marginTop: "2rem",
                        }}
                      >
                        <ChantCheckbox
                          type="secondary"
                          label={
                            <span style={{ color: "var(--text-color)" }}>
                              Lock/Archive Account
                            </span>
                          }
                          control={control}
                          name="lockStatus"
                          disabled={isSaving}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="mt-4">
                    <ChantSelect
                      label={
                        <span
                          style={{
                            fontWeight: "bold",
                            color: "var(--text-color)",
                          }}
                        >
                          Role
                        </span>
                      }
                      helpTooltip={
                        <Tooltip
                          placement="right"
                          title={
                            <img
                              src={MemberRoleTooltipIcon}
                              alt="edit role"
                              style={{ width: "600px", height: "auto" }}
                            />
                          }
                        >
                          <InfoCircleOutlined />
                        </Tooltip>
                      }
                      control={control}
                      name="userRole"
                      placeholder="Select role"
                      tabIndex="2"
                      disabled={isSaving}
                      options={userRoles.map((role) => ({
                        value: role,
                        label: role,
                      }))}
                    />

                    <span
                      style={{ fontSize: "12px", color: "var(--text-color)" }}
                    >
                      {ROLE_HELP_TOOLTIP[formState?.values?.userRole]}
                    </span>

                    {isLinkedGroup &&
                      formState.dirtyFields?.userRole &&
                      ["admin", "leader"].includes(selectedRole) && (
                        <Alert
                          type="info"
                          showIcon
                          style={{ marginTop: 10, fontSize: 12 }}
                          message="Role not updated in linked group"
                          description="This group is linked to another group. The role change applies only here — you'll need to update the role in the linked group manually."
                        />
                      )}
                  </div>

                  {["leader", "admin", "capo"].includes(
                    formState?.values?.userRole,
                  ) && <LeaderDetails control={control} isSaving={isSaving} />}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="px-4 py-5 col-md-8"
          style={{
            width: "80% !important",
            color: "#000000",
            display: "flex",
            flexDirection: "column",
            gap: "12px",
          }}
        >
          {fieldsLoading ? (
            <ChantSpinner />
          ) : (
            <>
              <div className="row">
                <div className="col-md-6">
                  <ChantInput
                    label={<span>Full Name</span>}
                    control={control}
                    name="name"
                    placeholder="Enter first name"
                    tabIndex="2"
                    disabled={isSaving}
                    rules={{
                      required: "Name is required",
                      minLength: {
                        value: 2,
                        message: "Name must be at least 2 characters",
                      },
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <ChantInput
                    label={<span>Email</span>}
                    control={control}
                    name="email"
                    placeholder="Enter email"
                    tabIndex="2"
                    disabled={isSaving}
                    rules={{
                      required: "Email is required",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Please enter a valid email address",
                      },
                    }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <ChantInput
                    label={<span>Hometown</span>}
                    control={control}
                    name="hometown"
                    placeholder="Enter hometown"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                </div>
                <div className="col-md-6">
                  <ChantSelect
                    label={<span>Member Since</span>}
                    control={control}
                    name="memberSince"
                    placeholder="Select year"
                    tabIndex="2"
                    disabled={isSaving}
                    options={years}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <ChantInput
                    label={
                      <div
                        style={{
                          display: "flex",
                          gap: "4px",
                          alignItems: "center",
                        }}
                      >
                        <span>Phone</span>

                        <HelpTooltip
                          text="Phone number displayed is what the member shared when buying
                              their membership package. It does not control app
                              authentication. We hide that number, treating it like a
                              Username. Request change from support@chant.fan."
                        />
                      </div>
                    }
                    control={control}
                    name="phone"
                    placeholder="Enter phone"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                  <p style={{ fontSize: "12px", color: "#fc3a3a" }}>
                    Note: Changing this # does not change authentication #
                  </p>
                </div>
                <div className="col-md-6">
                  <BirthDayField
                    control={control}
                    name="birthday"
                    value={watchedValues.birthday || userDetails.birthday || {}}
                    onChange={(value) => {
                      setValue("birthday", value);
                    }}
                  />
                </div>
              </div>
              <div className="row">
                {packagesBySeason?.length > 0 && (
                  <div className="col-md-6">
                    <ChantSelect
                      label={<span>Package</span>}
                      control={control}
                      name="package"
                      placeholder="Select package"
                      tabIndex="2"
                      disabled={isSaving}
                      options={packagesBySeason.map((pkg) => ({
                        value: pkg.key,
                        label: pkg.value,
                      }))}
                      onChange={(value) => {
                        // Update the form field value
                        setValue("package", value);

                        // Update local state for UI logic
                        const selectedPkg = currentPackages.find(
                          (pkg) =>
                            String(pkg?.id) === String(value) &&
                            String(pkg?.season) ===
                              String(userDetails?.packageSeason),
                        );
                        if (selectedPkg) {
                          setSelectedPackage(selectedPkg);
                        }
                      }}
                    />
                  </div>
                )}

                {selectedPackage &&
                  selectedPackage.offerAutorenewal &&
                  userDetails?.subscriptionDetail && (
                    <div className="col-md-6">
                      <ChantInput
                        control={control}
                        label={<span>Renewal Date</span>}
                        value={
                          userDetails?.subscriptionDetail
                            ? renewalDate.format("MM-DD-YYYY")
                            : ""
                        }
                        name=""
                        disabled={true}
                        placeholder="Renewal Date"
                        tabIndex="2"
                      />
                    </div>
                  )}
              </div>

              <div className="row">
                <div className="col-md-6">
                  <ChantInput
                    label={<span>Street name</span>}
                    control={control}
                    name="address1"
                    placeholder="Enter street address"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                </div>
                <div className="col-md-6">
                  <ChantInput
                    label={<span>Address2</span>}
                    control={control}
                    name="address2"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <ChantInput
                    label={<span>City</span>}
                    control={control}
                    name="city"
                    placeholder="Enter city"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                </div>
                <div className="col-md-6">
                  <ChantInput
                    label={<span>State/Province/Region</span>}
                    control={control}
                    name="state"
                    placeholder="Enter state"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <ChantSelect
                    label={<span>Country</span>}
                    control={control}
                    name="country"
                    placeholder="Select country"
                    tabIndex="2"
                    disabled={isSaving}
                    options={countryNames.map((country) => ({
                      value: country.name,
                      label: country.name,
                    }))}
                  />
                </div>
                <div className="col-md-6">
                  <ChantInput
                    label={<span>Zip/Postal</span>}
                    control={control}
                    name="zip"
                    placeholder="Enter zip"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <ChantInput
                    label={<span>Official Club Member</span>}
                    control={control}
                    name="officialClubMember"
                    placeholder="Official club member#"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                </div>
                <div className="col-md-6">
                  <SeasonTicketHolder
                    control={control}
                    name="seasonTicketHolder"
                  />
                </div>
                {hasTshirt && (
                  <div className="col-md-6">
                    <ChantSelect
                      label={<span>T-shirt Size</span>}
                      control={control}
                      name="tshirtSize"
                      placeholder="Select T-shirt Size"
                      tabIndex="2"
                      disabled={isSaving}
                      options={sizes.map((size) => ({
                        value: size.value,
                        label: size.name,
                      }))}
                    />
                  </div>
                )}

                <div className="col-md-6">
                  <ChantInput
                    label={<span>Referrer</span>}
                    control={control}
                    name="referrer"
                    placeholder="Referrer"
                    tabIndex="2"
                    disabled={isSaving}
                  />
                </div>

                {registrationLayout.chapters &&
                  registrationLayout.chapters.length > 0 && (
                    <div className="col-md-6">
                      <ChantSelect
                        label={<span>Chapters</span>}
                        control={control}
                        name="chapter"
                        placeholder="Select chapter"
                        tabIndex="2"
                        disabled={isSaving}
                        options={registrationLayout.chapters.map((chapter) => ({
                          value: chapter,
                          label: chapter,
                        }))}
                      />
                    </div>
                  )}
              </div>
              <div className="edit-member-custom-fields">
                {Object.keys(customFields).map((key) => {
                  let value = customFields[key];
                  return (
                    <div
                      key={key}
                      style={
                        value.fieldType === "checkbox"
                          ? { display: "flex", alignItems: "center" }
                          : {}
                      }
                    >
                      {getCustomField(value, key, userDetails)}
                    </div>
                  );
                })}
              </div>

              {hasChildren && (
                <>
                  {Array.from({
                    length:
                      parseInt(
                        watchedValues.noOfChildren || userDetails.noOfChildren,
                      ) || 0,
                  }).map((_, index) => (
                    <div className="row" key={index}>
                      <div className="col-md-6">
                        <ChantInput
                          label={<span>{`Child #${index + 1} Name`}</span>}
                          control={control}
                          name={`children.${index}.name`}
                          placeholder="Name"
                          tabIndex="2"
                          disabled={isSaving}
                        />
                      </div>

                      {hasTshirt && (
                        <>
                          <div className="col-md-6">
                            <ChantSelect
                              label={<span>T-shirt Size</span>}
                              control={control}
                              name={`children.${index}.tshirtSize`}
                              placeholder="Select T-shirt Size"
                              tabIndex="2"
                              disabled={isSaving}
                              options={sizes.map((size) => ({
                                value: size.value,
                                label: size.name,
                              }))}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  ))}
                </>
              )}

              <div className="row">
                <div className="col">
                  <div className="col">
                    <div>
                      <label
                        style={{
                          marginBottom: 0,
                        }}
                      >
                        Notes
                      </label>
                    </div>
                    <Controller
                      name="notes"
                      control={control}
                      render={({ field }) => (
                        <Input.TextArea
                          className="col"
                          {...field}
                          disabled={isSaving}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>

              <div className="edit-member-footer">
                <ChantButton
                  type="secondary"
                  key="back"
                  onClick={() => {
                    handleModalOpen();
                    resetState();
                  }}
                >
                  Cancel
                </ChantButton>
                <ChantButton
                  key="submit"
                  onClick={handleSubmit(onSubmit)}
                  disabled={
                    !formState.isValid ||
                    !Object.keys(formState.dirtyFields).length > 0 ||
                    isSaving
                  }
                  loading={isSaving}
                >
                  {isSaving ? "Saving..." : "Save"}
                </ChantButton>
              </div>
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EditMember;
